export class QuestionBase<T> {
  value: T;
  key: string;
  label: string;
  required: boolean;
  order: number;
  controlType: string;
  labelCol: number;
  className: string;
  conditions: any;
  view_label: string;
  validations: any;
  sendInvisible: boolean;

  constructor(options: {
    value?: T,
    key?: string,
    label?: string,
    required?: boolean,
    order?: number,
    controlType?: string,
    labelCol?: number,
    conditions?: any;
    view_label?: string,
    validations?: any;
    sendInvisible?:boolean
  } = {}) {
    this.value = options.value;
    this.key = options.key || '';
    this.label = options.label || '';
    this.required = !!options.required;
    this.order = options.order === undefined ? 1 : options.order;
    this.controlType = options.controlType || '';
    this.labelCol = options.labelCol || 3;
    this.conditions = options.conditions || '';
    this.view_label = options.view_label || '';
    this.validations = options.validations || false;
    this.sendInvisible = options.sendInvisible || false;
  }
}
